import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shared/shared.service';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  
  SERVER_URL= environment.backend_server;

  auth_key:any;

  constructor(
    public http:HttpClient,
    public router:Router,
    private shared_service:SharedService
    ) { 

      this.shared_service.getAuthKey.subscribe(auth_key =>{
        this.auth_key=auth_key;
       
      });

    }

    getToken(token:any){
  
      this.setTokenSession(token);
    }

    setTokenSession(token:any){
    
      // let tst =  localStorage.setItem(environment.app_token,token);
 
      
      return localStorage.setItem(environment.app_token,token);

    }

    getTokenSession(){
      return localStorage.getItem(environment.app_token)
    }

    removeTokenSession(){
      
      return localStorage.removeItem(environment.app_token)
    }

    tokenPayload(token:any){


      const token_obj = this.shared_service.decrypt(this.auth_key,token);

      // this.shared_service.setUserData(token_obj.user);
      return token_obj;

    }

    isTokenValid(){

      const token = this.getTokenSession();
      
      if(token){
        
        const token_payload = this.tokenPayload(token);

        if(token_payload){

          let jwt_token = token_payload.jwt_token.original.access_token.split('.')[1];
          let decoded_jwt = JSON.parse(atob(jwt_token));
          
          return (decoded_jwt.iss=== `${this.SERVER_URL}/login`)?true:false
        }
      }

      return false;
    }

    isLoggedIn(){

      let data={};

      if(this.isTokenValid()){
        
        const token_payload = this.tokenPayload(this.getTokenSession());

        data ={
            isLoggedIn:this.isTokenValid(),
            user_data:this.tokenPayload(this.getTokenSession()).user,
            token_data:this.tokenPayload(this.getTokenSession())
          }

      }else{

        data ={
          isLoggedIn:this.isTokenValid(),
          user_type_access:null
        }


      }

      // const token_payload = this.tokenPayload(this.getTokenSession());

      // let data ={
      //   isLoggedIn:this.isTokenValid(),
      //   user_type_access:
      // }

      return data;
    }

    startUp(data:any){

      // const urlUsed = `${this.SERVER_URL}/api/fortesting/testing.php`;
      const urlUsed = `${this.SERVER_URL}/appstartup`;
     
      return this.http.post<any>(urlUsed, data);
    }

   

  
}
